import React, { Component } from 'react';
import { Container} from 'react-bootstrap';
import _ from 'lodash';
import { translate } from 'react-i18next';
import { EVENT } from '../../../common/events/listEvents';
import ToastComponent from '../ToastComponent';
import Constants from '../../../common/Constants';
import { observer, inject } from 'mobx-react';
import uuid from 'uuid/v1';
import Utils from '../../../common/Utils';

@translate([], {wait: true})
@inject('BetslipStore')
@observer
class ToastGeneratorComponent extends Component {

  constructor(props) {
    super(props);
    this.generateAddingSelectionToast = this.generateAddingSelectionToast.bind(this);
    this.generateToast = this.generateToast.bind(this);
    this.state = {
      toastItems: []
    }
  }
  componentDidMount() {
    window.listenEvent(EVENT.GENERATE_ADDING_SELECTION_TOAST, this.generateAddingSelectionToast);
    window.listenEvent(EVENT.GENERATE_TOAST, this.generateToast);
    window.listenEvent(EVENT.CLEAR_ALL_TOASTS, this.clearAllToasts)
    window.listenEvent(EVENT.CLEAR_PENDING_BET_TOAST, this.clearPendingBetToast)
  }

  componentWillUnmount() {
    window.stopListenEvent(EVENT.GENERATE_ADDING_SELECTION_TOAST, this.generateAddingSelectionToast);
    window.stopListenEvent(EVENT.GENERATE_TOAST, this.generateToast);  
    window.stopListenEvent(EVENT.CLEAR_ALL_TOASTS, this.clearAllToasts);
    window.listenEvent(EVENT.CLEAR_PENDING_BET_TOAST, this.clearPendingBetToast)
  }

  removeTimeoutToast(toastId) {
    let filter = this.state.toastItems.filter((toast, idx) => {
      return toastId !== toast.toastId;
    })
    this.setState({
      toastItems: filter
    });
  }

  clearPendingBetToast = () => {
    const filter = this.state.toastItems.filter(toast => !(toast.disableTimer && toast.toastStatus === Constants.TOAST.TOAST_CLASS_WARNING))
    this.setState({
      toastItems: filter
    });
  }
  
  clearAllToasts = () => {
    this.setState({toastItems: []})
  }

  generateToast() {
    const newToast = {...window.toastComp, toastId: uuid()}

    this.setState(prevState => ({
      toastItems: [...prevState.toastItems, newToast]
    }));
  }

  generateAddingSelectionToast() {
    let toastComp = window.toastComp;
    const duplicateToast = this.props.BetslipStore.getOddsSelections.filter(item => {
      return item.oddsId === toastComp.oddsId;
    });

    if (duplicateToast.length > 0) {
      toastComp.className = Constants.TOAST.TOAST_CLASS_WARNING;
      toastComp.messages[0] = Constants.TOAST.EXISTING_BET_MESSAGE;
    }
    const newToast = {
      selectionId: toastComp.oddsId,
      messages: toastComp.messages,
      className: toastComp.className,
      tapOnLinkAction: toastComp.tapOnLinkAction,
      toastId: uuid()
    };
    this.setState(prevState => ({
      toastItems: [...prevState.toastItems, newToast]
    }));
  }

  renderToasts() {
    const toastItems = [];
    _.forEach(this.state.toastItems, (toastProps, index) => {
      const { isNewToast } = toastProps;

      if (isNewToast) {
        toastItems.unshift(
          <ToastComponent
            key={index}
            {...toastProps}
            removeTimeoutToast={this.removeTimeoutToast.bind(this)}
            clearAllToasts={this.clearAllToasts.bind(this)}
          />
        )
      }
      else {
        toastItems.push(
          <ToastComponent
            key={index}
            {...toastProps}
            removeTimeoutToast={this.removeTimeoutToast.bind(this)}
            clearAllToasts={this.clearAllToasts.bind(this)}
          />
        )
      }
    })
    return toastItems;
  }

  render() {
    const clazz = `toast-container ${Utils.getViewByURLPath()} ${window.env.enableNewBetslip && Utils.isMobileAsianView() ? 'new-betslip-enabled' : ''}`
    return(
      <React.Fragment>
        <Container className={clazz}>
          {this.renderToasts()}
        </Container>
      </React.Fragment>
    )
  }

}

export default ToastGeneratorComponent;


// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/ToastGeneratorComponent/index.js